import { getList } from '../service/backSchool';

const initState = () => {
  return {
    data: [],
  };
};

export default {
  namespace: 'backSchoolModel',
  state: initState(),
  effects: {
    *fetchList(_, { call, put }) {
      try {
        const data = yield call(getList);
        yield put({
          type: 'save',
          payload: {
            data,
          },
        });
      } catch (error) {
        console.log(error, 'fetchList')
      }
    },
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
